import React from "react";

import Sidebar from "components/Sidebar";
export default function Products() {
  return (
    <div className="flex">
      <Sidebar />
      <div>Products</div>
    </div>
  );
}
